<template>
  <header :class="className">
    <div v-show="stickyActive" :ref="stickyActive ? 'header' : null" :style="{ height: `${placeholderHeight}px` }" />
    <div :ref="stickyActive ? null : 'header'" :class="{ 'header--sticky animate': stickyActive }">
      <div class="header__inner">
        <div class="header__container">
          <div class="header__left">
            <a v-if="logoLink" :href="logoLink" :aria-label="logoLinkAriaLabel">
              <logo :type="logo" class="header__logo" />
            </a>
            <logo v-else :type="logo" class="header__logo" />
          </div>
          <div class="header__right">
            <header-content v-if="contentProps || $slots.default" v-bind="contentProps">
              <slot />
            </header-content>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Logo from "@/component-library/b-logo"
import HeaderContent from "./header-content"
import bemBlockModifiers from "@/utils/bem-block-modifiers"
import globals from "@/utils/globals"
import getLocale from "@/utils/locale"

const routes = globals.routes || {}

export default {
  name: "Header",
  components: {
    Logo,
    HeaderContent
  },
  props: {
    isSticky: { type: Boolean, default: false },
    modifiers: { type: Array, default: () => [] },
    hasLogoLink: { type: Boolean, default: true },
    hasJsPopupClass: { type: Boolean, default: true },
    contentProps: { type: Object, default: null },
    logo: { type: String, default: "full" },
    inviteCode: { type: String, default: "" }
  },
  data() {
    return {
      stickyActive: false,
      placeholderHeight: 0,
      show: true
    }
  },
  computed: {
    className() {
      return bemBlockModifiers("header", this.modifiers)
    },
    logoLink() {
      if (this.hasLogoLink) {
        if (this.logo === "business") {
          return routes.business
        }
        return routes.root || `/${getLocale()}`
      } else {
        return null
      }
    },
    logoLinkAriaLabel() {
      if (this.hasLogoLink) {
        if (this.logo === "business") {
          return "Blinkist Business homepage"
        } else {
          return "Blinkist homepage"
        }
      } else {
        return null
      }
    }
  },
  mounted() {
    if (this.isSticky) {
      this.initStickyHeader()
    }
  },
  methods: {
    onScroll() {
      const headerRef = this.$refs.header.getBoundingClientRect()
      this.placeholderHeight = headerRef.height
      if (headerRef.bottom < 0 && headerRef.top * -1 > headerRef.height) {
        this.stickyActive = true
      } else {
        this.stickyActive = false
      }
    },
    initStickyHeader() {
      window.addEventListener("scroll", this.onScroll)
    }
  }
}
</script>

<style lang="scss">
@import "app/assets/stylesheets/layouts/header";

.animate {
  animation: fadeInDown 0.25s ease;
}

@keyframes fadeInDown {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
</style>
